import { useQuery } from "@apollo/client";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import style from "../assets/css/page/Player.module.css";
import EfficiencyPlayer from "../components/Chart/EfficiencyPlayer";
import LogoHeader from "../components/Header/LogoHeader";
import Loading from "../components/Loading";
import { GET_PLAYER, GET_TOURNAMENTS } from "../graphql/queries";
import Modal from "../components/Modal";
import useUpdatePlayer from "../hooks/useUpdatePlayer";

const modalStates = { removePlayer: false };

function Player() {
  const role = window.localStorage.getItem("role");
  const location = useLocation();
  const tournaments = useQuery(GET_TOURNAMENTS);
  const { updatePlayer } = useUpdatePlayer();
  const [activeModals, setActiveModals] = useState(modalStates);
  const navigate = useNavigate();

  let numRegister = location.state?.numRegPlayer;
  console.log(numRegister);

  const changeModalState = (modal) => async () => {
    setActiveModals({ ...activeModals, [modal]: !activeModals[modal] });
  };

  const { data, loading, error } = useQuery(GET_PLAYER, {
    variables: {
      IdPlayer: location.state?.idPlayer,
      State: "LIVE",
    },
  });

  if (loading || tournaments.loading) return <Loading />;

  if (error)
    return (
      <div>
        <p>Lo sentimos a ocurrido un error al traer los datos</p>
      </div>
    );

  const getTotalPlayed = () => {
    if (data?.player?.dayRegister <= 3) {
      return 17;
    } else if (data?.player?.dayRegister === 8) {
      return 10;
    } else {
      return 0;
    }
  };

  const calculatePercent = (played, games) => {
    const result = Math.round((played * 100) / games);
    return result ? [result] : [0];
  };

  const DeletePlayer = async () => {
    const response = await updatePlayer(data?.player?.id, {
      id: data?.player?.id,
      team: null,
    });
    if (response?.id) {
      navigate(-1);
    }
  };

  return (
    <div className={style.container}>
      <div className={style.header}>
        <LogoHeader />
        {tournaments.data.tournaments[0].registerPlayers && 
          role === "leader" && numRegister > 0 && (
          <button
            className={style.btnRemove}
            onClick={changeModalState("removePlayer")}
          >
            Desvincular
          </button>
        )}
      </div>
      <div className={style.content}>
        <div className={style.contPlayer}>
          <div className={style.player}>
            <div className={style.contNumber}>
              <p className={style.number}>
                <span>#</span>
                {data?.player?.numShirt < 10
                  ? `0${data?.player?.numShirt}`
                  : data?.player?.numShirt}
              </p>
            </div>
            <div className={style.data}>
              <p className={style.position}>{data?.player?.position}</p>
              <p className={style.name}>{data?.player?.name}</p>
              <p
                className={style.lastName}
                style={{ color: data?.player?.team?.colorShirt }}
              >
                {data?.player?.app}
              </p>
              <div className={style.team}>
                <p className={style.shield}>
                  <FontAwesomeIcon
                    icon={faShieldAlt}
                    color={data?.player?.team?.colorShirt}
                  />
                </p>
                <p className={style.name}>{data?.player?.team?.name}</p>
              </div>
            </div>
          </div>
        </div>
        <div className={style.contStadistic}>
          <div className={style.charts}>
            <EfficiencyPlayer
              teamColor={data?.player?.team?.colorShirt}
              series={calculatePercent(data?.player?.played, getTotalPlayed())}
            />
          </div>
          <div className={style.stadistic}>
            <DataPlayer
              title="Tarjetas Amarillas"
              data={data?.player?.yellowCard}
            />
            <DataPlayer title="Tarjetas Rojas" data={data?.player?.redCard} />
            <DataPlayer title="Partidos Jugados" data={data?.player?.played} />
            <DataPlayer title="Goles anotados" data={data?.player?.goal} />
          </div>
        </div>
      </div>
      <Modal
        title="Desvincular jugador del equipo"
        show={activeModals.removePlayer}
        close={changeModalState("removePlayer")}
      >
        <Delete data={data} deletePlayer={DeletePlayer} />
      </Modal>
    </div>
  );
}

const DataPlayer = ({ title, data }) => (
  <div className={style.card}>
    <p className={style.title}>{title}</p>
    <p className={style.data}>{data}</p>
  </div>
);

const Delete = ({ data, deletePlayer }) => {
  return (
    <div className={style.contDelete}>
      <p className={style.text}>¿Seguro que quieres eliminar a este jugador?</p>
      <p
        className={style.name}
      >{`${data?.player?.name} ${data?.player?.app}`}</p>
      <button className={style.btnDelete} onClick={deletePlayer}>
        Si, eliminar
      </button>
    </div>
  );
};

export default Player;
